import { render, staticRenderFns } from "./request.vue?vue&type=template&id=21490acc&"
import script from "./request.vue?vue&type=script&lang=ts&"
export * from "./request.vue?vue&type=script&lang=ts&"
import style0 from "./request.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports